// extracted by mini-css-extract-plugin
module.exports = {"back-top-wrapper":"back-top-wrapper___3B2zq"};